export default __webpack_public_path__ + "static/media/LeftChevron.e4c1b9fe.svg";